module.exports = __webpack_public_path__ + "static/media/artisanWomen.5be38d78.jpg";